import Tool, { type IToolActionInput, type IToolEnabledInput } from './Tool';

class ToolCopyLink extends Tool {
  static toolName = 'Copy link to object(s)';

  static action({ controller, selection }: IToolActionInput) {
    let selectedObjects: fabric.Object[];
    if (selection.type === 'activeSelection') {
      selectedObjects = selection.getObjects();
    } else {
      selectedObjects = [selection];
    }

    const whiteboardUrl = controller.getWhiteboardUrl();

    if (selectedObjects.length === 0 || !whiteboardUrl) {
      return;
    }

    const url = new URL(whiteboardUrl);
    url.hash = '#object-' + selectedObjects.map(o => o.id).join('-');

    navigator.clipboard.writeText(url.toString());
  }

  static enabled({ selection }: IToolEnabledInput): boolean {
    if (!selection) {
      return false;
    }

    if (selection.type !== 'activeSelection') {
      return true;
    }
    const length = selection.getObjects().length;
    return length > 0 && length <= 20;
  }
}

export default ToolCopyLink;
